import { render, staticRenderFns } from "./BannerProducerRural.vue?vue&type=template&id=3ccfce41&scoped=true"
import script from "./BannerProducerRural.vue?vue&type=script&lang=js"
export * from "./BannerProducerRural.vue?vue&type=script&lang=js"
import style0 from "./BannerProducerRural.vue?vue&type=style&index=0&id=3ccfce41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccfce41",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ButtonComponent: require('/home/luiz/Sistemas/loja/components/ButtonComponent.vue').default})
